<template>
  <div class="flex h-full w-full flex-col" :class="!link && 'relative pr-6'">
    <div v-if="link" class="mb-5 flex items-center justify-between">
      <div class="min-h-[30px]">
        <TheButton :to="link.url" :title="buttonName" class="flex items-center">
          <span class="text-sm">{{ buttonName }}</span>
          <IconCaret direction="right" class="ml-1 h-5 w-5 text-white" />
        </TheButton>
      </div>
      <button class="h-6 w-6" @click="handleClose">
        <IconClose class="h-full w-full text-gray-600 hover:text-blue-400" />
      </button>
    </div>

    <button v-else class="absolute right-0 top-0 h-6 w-6" @click="handleClose">
      <IconClose class="h-full w-full text-gray-600 hover:text-blue-400" />
    </button>

    <div
      class="container-scrollbar h-full w-full overflow-y-auto overflow-x-hidden overscroll-y-contain"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  interface ILink {
    url: string;
    target: number;
  }

  interface IProps {
    link?: ILink | null;
    type?: string;
  }

  const props = withDefaults(defineProps<IProps>(), {
    link: null,
    type: '',
  });

  const { t } = useI18n();
  const menuStore = useMenuStore();
  const { menuName } = storeToRefs(menuStore);

  const buttonName = computed((): string => {
    return props.type === menuName.value.SOLUTIONS
      ? t('menu.content.overview-button')
      : t('menu.content.view-all-button');
  });

  const handleClose = (): void => {
    menuStore.HANDLE_CLOSE_MENU();
  };
</script>
